module.exports = __webpack_public_path__ + "static/anna-portrait-fecb0bd08d68c32c96b8cfb8af41af81.jpg";